export { default } from './Tooltip';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Backoffice/Tooltip/index.js